// CategoryPage.js
import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import ProductList from './ProductList';
import { products } from '../products';
import { FaArrowLeft } from 'react-icons/fa';
import '../css/CategoryPage.css';

const CategoryPage = () => {
    const { category } = useParams();
    const navigate = useNavigate();
    
    // Filter products by category
    const categoryProducts = products.filter(product => 
        product.category.toLowerCase() === category.toLowerCase()
    );

    const handleGoBack = () => {
        navigate(-1); // Go back to previous page
    };

    return (
        <div className="category-page">
            <button onClick={handleGoBack} className="go-back-button">
                <FaArrowLeft />
                <span>Go Back</span>
            </button>
            
            <div className="category-header">
                <h1>{category.charAt(0).toUpperCase() + category.slice(1)}</h1>
                <p>{categoryProducts.length} products found</p>
            </div>
            
            {categoryProducts.length > 0 ? (
                <ProductList products={categoryProducts} />
            ) : (
                <div className="no-products">
                    <h2>No products found in this category</h2>
                    <Link to="/products" className="back-to-products">
                        View All Products
                    </Link>
                </div>
            )}
        </div>
    );
};

export default CategoryPage;